import React from "react";
class Overlay extends React.Component {
  onChange = (event) => {
    this.props.onChange(this.props.item.key, event.target.value);
  };
  render() {
    if (this.props.struct) {
      console.log(this.props.struct);
    }
    return (
      <React.Fragment>
        <label
          className="overlay-label"
          htmlFor={`overlay-${this.props.item.nb}`}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Overlay</span> <span>{this.props.item.nb}</span>
          </div>
        </label>
        <input
          id={`overlay-${this.props.item.nb}`}
          className="overlay-input"
          value={this.props.item.color}
          onChange={this.onChange}
          spellCheck={false}
          template="rgba(0, 0, 0, 0)"
        ></input>

        <span
          onClick={() => this.props.onDelete(this.props.item.nb)}
          title="Delete overlay"
          className="overlay-delete"
        >
          <svg style={{ width: 17, height: 17 }}>
            <use href="#close-icon"></use>
          </svg>
        </span>
      </React.Fragment>
    );
  }
}

export default Overlay;
/*
<button
className="overlay-delete"
onClick={() => this.props.onDelete(this.props.item.key)}
>
Delete{" "}
<span style={{ fontWeight: "bold", color: "red" }}>&#x1F5D9;</span>
</button>
*/
